<template>
  <div>
    <vheader />
    <iframe :src="url" frameborder="0" id="show-iframe" style></iframe>
  </div>
</template>

<script>
import Vheader from "../header/VHeader";
export default {
  components: {
    Vheader
  },
  data() {
    return {
      classId: "",
      url: ""
    };
  },
  mounted() {
    this.frame()
  },

 watch: {
    classId: {
      handler() {
        this.showClass();
      }
    },
    $route: {
      deep: true,
      handler(val) {
        var url = location.href;
        var str = url.split('/')
        str = str.pop()
        this.classId = str;
      }
    }
  },

  methods: {
    showClass() {
      console.log(this.classId)

      if (this.classId === "cskf.html") {
        this.url = "/static/cskf/index.html";
      } else if (this.classId === "renzheng.html") {
        this.url = "/static/istqb/index.html";
      } else if (this.classId === "csjy.html") {
        this.url = "/static/jypx/index.html";
      } else if (this.classId === "neixun.html") {
        this.url = "/static/tdnx/index.html";
      } else if (this.classId === "weipei.html") {
        this.url = "/static/wpzt/index.html";
      } else if (this.classId === "zhoumo.html") {
        this.url = "/static/zmjp/index.html";
      } else if (this.classId === "xueli.html") {
        this.url = "/static/zsb/index.html";
      } else if (this.classId === "python.html") {
        this.url = "/static/python/index.html";
      } 
      else if (this.classId === "mcar.html") {
        this.url = "/static/car/mobile.html";
      } 
    },
    frame(){
      var url = location.href;
      if(~url.indexOf('?')){
        url = url.split('?')[0]
      }
    var str = url.split('/')
    str = str.pop()
    this.classId = str;
    const oIframe = document.getElementById("show-iframe");
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.width = deviceWidth + "px";
    oIframe.style.height = deviceHeight - 165 + "px";
    var frame = document.getElementById("show-iframe");
    frame.onload = function() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        var iframebody = frame.contentWindow.document.body;
        iframebody.style.width = document.body.clientWidth + "px";
        iframebody.style.height = oIframe.style.height;
      }
    };
    }
  }
};
</script>

<style scoped>
iframe {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  min-width: 100%;
  *width: 100%;
  width: 1px;
  /* margin-bottom: 120px !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/classPage/ClassPage.vue